	
     <!--SECTION START HERE-->
     <section class="sec-main-w section">
      <div class="container">
        <div class="sec-hdr-title text-center">
          <h1>Best Sellers</h1> </div>
        <div class="man-sr-row">
          <div class="mt-sr-vw">
            <div class="mt-sr-img">
              <div class="sale-tag"> <span class="sale-b">SALE</span> </div> <img src="../assets/images/saree-img-001.png"> </div>
            <div class="mt-sr-info">
              <div class="nt-sr-sname">Ocean Blue South Silk Saree</div>
              <div class="nt-sr-price">
                <div class="nt-sr-mainprice">₹ 4,500</div>
                <div class="nt-sr-discprice">₹ 15,000</div>
              </div>
              <div class="mt-cta-hero"> <a class="button button-primary" href="#">Bu it Now</a> </div>
            </div>
          </div>
          <div class="mt-sr-vw">
            <div class="mt-sr-img">
              <div class="sale-tag"> <span class="sale-b">SALE</span> </div> <img src="../assets/images/saree-img-002.png"> </div>
            <div class="mt-sr-info">
              <div class="nt-sr-sname">Ocean Blue South Silk Saree</div>
              <div class="nt-sr-price">
                <div class="nt-sr-mainprice">₹ 4,500</div>
                <div class="nt-sr-discprice">₹ 15,000</div>
              </div>
              <div class="mt-cta-hero"> <a class="button button-primary" href="#">Bu it Now</a> </div>
            </div>
          </div>
          <div class="mt-sr-vw">
            <div class="mt-sr-img">
              <div class="sale-tag"> <span class="sale-b">SALE</span> </div> <img src="../assets/images/saree-img-003.png"> </div>
            <div class="mt-sr-info">
              <div class="nt-sr-sname">Ocean Blue South Silk Saree</div>
              <div class="nt-sr-price">
                <div class="nt-sr-mainprice">₹ 4,500</div>
                <div class="nt-sr-discprice">₹ 15,000</div>
              </div>
              <div class="mt-cta-hero"> <a class="button button-primary" href="#">Bu it Now</a> </div>
            </div>
          </div>
          <div class="mt-sr-vw">
            <div class="mt-sr-img">
              <div class="sale-tag"> <span class="sale-b">SALE</span> </div> <img src="../assets/images/saree-img-004.png"> </div>
            <div class="mt-sr-info">
              <div class="nt-sr-sname">Ocean Blue South Silk Saree</div>
              <div class="nt-sr-price">
                <div class="nt-sr-mainprice">₹ 4,500</div>
                <div class="nt-sr-discprice">₹ 15,000</div>
              </div>
              <div class="mt-cta-hero"> <a class="button button-primary" href="#">Bu it Now</a> </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
 
    <section class="features section">
      <div class="container">
        <div class="features-inner section-inner">
          <div class="features-header text-center">
            <div class="container-sm">
              <h2 class="section-title mt-0">Top Categories to choose from</h2> </div>
          </div>
          <div class="features-wrap">
            <div class="feature text-center is-revealing">
              <div class="feature-inner">
                <div class="feature-icon"> <img src="./assets/images/img-one.png"> </div>
                <h4 class="feature-title h3-mobile mb-8">Sarees</h4> </div>
            </div>
            <div class="feature text-center is-revealing">
              <div class="feature-inner">
                <div class="feature-icon"> <img src="./assets/images/img-two.png"> </div>
                <h4 class="feature-title h3-mobile mb-8">Kids</h4> </div>
            </div>
            <div class="feature text-center is-revealing">
              <div class="feature-inner">
                <div class="feature-icon"> <img src="./assets/images/img-three.png"> </div>
                <h4 class="feature-title h3-mobile mb-8">Gadwal Silk</h4> </div>
            </div>
            <div class="feature text-center is-revealing">
              <div class="feature-inner">
                <div class="feature-icon"> <img src="./assets/images/img-one.png"> </div>
                <h4 class="feature-title h3-mobile mb-8">Sarees</h4> </div>
            </div>
            <div class="feature text-center is-revealing top-80">
              <div class="feature-inner">
                <div class="feature-icon"> <img src="./assets/images/img-two.png"> </div>
                <h4 class="feature-title h3-mobile mb-8">Kids</h4> </div>
            </div>
            <div class="feature text-center is-revealing">
              <div class="feature-inner">
                <div class="feature-icon"> <img src="./assets/images/img-three.png"> </div>
                <h4 class="feature-title h3-mobile mb-8">Gadwal Silk</h4> </div>
            </div>
          </div>
        </div>
      </div>
    </section>
      
 
            
              <!--SECTION START HERE-->
              <section class="sec-main-w section">
                <div class="container">
                  <div class="sec-hdr-title text-center">
                    <h1>Best Sellers</h1> </div>
                  <div class="man-sr-row">
                    <div class="mt-sr-vw">
                      <div class="mt-sr-img">
                        <div class="sale-tag"> <span class="sale-b">SALE</span> </div> <img src="../assets/images/saree-img-001.png"> </div>
                      <div class="mt-sr-info">
                        <div class="nt-sr-sname">Ocean Blue South Silk Saree</div>
                        <div class="nt-sr-price">
                          <div class="nt-sr-mainprice">₹ 4,500</div>
                          <div class="nt-sr-discprice">₹ 15,000</div>
                        </div>
                        <div class="mt-cta-hero"> <a class="button button-primary" href="#">Bu it Now</a> </div>
                      </div>
                    </div>
                    <div class="mt-sr-vw">
                      <div class="mt-sr-img">
                        <div class="sale-tag"> <span class="sale-b">SALE</span> </div> <img src="../assets/images/saree-img-002.png"> </div>
                      <div class="mt-sr-info">
                        <div class="nt-sr-sname">Ocean Blue South Silk Saree</div>
                        <div class="nt-sr-price">
                          <div class="nt-sr-mainprice">₹ 4,500</div>
                          <div class="nt-sr-discprice">₹ 15,000</div>
                        </div>
                        <div class="mt-cta-hero"> <a class="button button-primary" href="#">Bu it Now</a> </div>
                      </div>
                    </div>
                    <div class="mt-sr-vw">
                      <div class="mt-sr-img">
                        <div class="sale-tag"> <span class="sale-b">SALE</span> </div> <img src="../assets/images/saree-img-003.png"> </div>
                      <div class="mt-sr-info">
                        <div class="nt-sr-sname">Ocean Blue South Silk Saree</div>
                        <div class="nt-sr-price">
                          <div class="nt-sr-mainprice">₹ 4,500</div>
                          <div class="nt-sr-discprice">₹ 15,000</div>
                        </div>
                        <div class="mt-cta-hero"> <a class="button button-primary" href="#">Bu it Now</a> </div>
                      </div>
                    </div>
                    <div class="mt-sr-vw">
                      <div class="mt-sr-img">
                        <div class="sale-tag"> <span class="sale-b">SALE</span> </div> <img src="../assets/images/saree-img-004.png"> </div>
                      <div class="mt-sr-info">
                        <div class="nt-sr-sname">Ocean Blue South Silk Saree</div>
                        <div class="nt-sr-price">
                          <div class="nt-sr-mainprice">₹ 4,500</div>
                          <div class="nt-sr-discprice">₹ 15,000</div>
                        </div>
                        <div class="mt-cta-hero"> <a class="button button-primary" href="#">Bu it Now</a> </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>